module.exports = __webpack_public_path__ + "img/proyectos_act.fedcf876.png";